const STOREFRONT_ACCESS_TOKEN = 'YOUR_STOREFRONT_TOKEN';
const SHOP_DOMAIN = 'kptrading.uk';

async function fetchProducts() {
  const query = `
  {
    products(first: 10) {
      edges {
        node {
          id
          title
          handle
          description
          images(first: 1) {
            edges {
              node {
                url
              }
            }
          }
          variants(first: 1) {
            edges {
              node {
                price {
                  amount
                  currencyCode
                }
              }
            }
          }
        }
      }
    }
  }`;

  const response = await fetch(`https://${SHOP_DOMAIN}/api/2024-01/graphql.json`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': STOREFRONT_ACCESS_TOKEN
    },
    body: JSON.stringify({ query })
  });

  const result = await response.json();
  console.log('Shopify Products:', result);
}

fetchProducts();